<template>
  <div>
    <Nav />
    <div class="row flex-xl-nowrap w-100">
      <SideNav />
      <div
        ref="main"
        class="main col-12 col-md-9 col-xl-10 py-md-3 p-md-5 bd-content bg-light rounded overflow-auto"
      >
        <div class="row justify-content-between">
          <div>
            <div class="d-flex justify-content-between">
              <header class="p-2 d-flex align-items-end">
                <h2>Quotes</h2>
              </header>
            </div>
          </div>
          <div class="d-flex flex-column flex-lg-row query">
            <div class="p-2 d-flex align-items-end">
              <input
                v-model="q"
                v-debounce:500ms="searchQ"
                type="text"
                class="form-control"
                placeholder="Search..."
              />
            </div>
            <div class="p-2 d-flex align-items-end">
              <div class="px-2 d-flex">
                <div class="mr-2">
                  <label><small>From:</small></label>
                  <input
                    @input="search"
                    v-model="date"
                    type="date"
                    class="form-control"
                  />
                </div>

                <div>
                  <label><small>To:</small></label>
                  <input
                    @input="search"
                    v-model="endDate"
                    type="date"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="p-2 d-flex align-items-end paginate">
              <button class="btn btn-secondary btn-sm" @click="leftClick">
                <ArrowLeftThick />
              </button>
              <input type="text" class="form-control" v-model="page" />
              <button class="btn btn-secondary btn-sm" @click="rightClick">
                <ArrowRightThick />
              </button>
            </div>
          </div>
        </div>

        <div class="row bg-white p-3 my-2 item-row item-head">
          <div class="col-md-2 d-flex align-items-center">
            <p>Fullname</p>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <p>Job Title</p>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <p>Email</p>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <p>Company Name</p>
          </div>
          <div class="col-md-1 d-flex align-items-center">
            <p>Size</p>
          </div>
          <div class="col-md-3 d-flex align-items-center">
            <p>Message</p>
          </div>
        </div>

        <div
          v-for="quote in allQuotes"
          :key="quote._id"
          class="row bg-white p-3 my-2 item-row"
        >
          <div class="col-md-2 d-flex align-items-center">
            <p>{{ quote.fullname }}</p>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <p>{{ quote.jobtitle }}</p>
          </div>
          <div class="col-md-2 d-flex align-items-center word-break">
            <p>{{ quote.email }}</p>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <p>{{ quote.company_name }}</p>
          </div>
          <div class="col-md-1 d-flex align-items-center">
            <p>{{ quote.company_size }}</p>
          </div>
          <div class="col-md-3 d-flex align-items-center">
            <p>
              {{ quote.createdAt.split("T")[0] }}<br />
              {{ quote.message }}
            </p>
          </div>
        </div>

        <div class="p-2 d-flex align-items-end paginate my-4">
          <button
            class="btn btn-secondary btn-sm"
            @click="
              scrollTop('main');
              leftClick();
            "
          >
            <ArrowLeftThick />
          </button>
          <input type="text" class="form-control" v-model="page" />
          <button
            class="btn btn-secondary btn-sm"
            @click="
              scrollTop('main');
              rightClick();
            "
          >
            <ArrowRightThick />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "../components/SideNav.vue";
import Nav from "../components/Nav.vue";
import ArrowRightThick from "vue-material-design-icons/ArrowRightThick.vue";
import ArrowLeftThick from "vue-material-design-icons/ArrowLeftThick.vue";
import { mapGetters, mapActions } from "vuex";
import { truncate } from "../utils";

export default {
  name: "Quotes",
  components: {
    SideNav,
    Nav,
    ArrowRightThick,
    ArrowLeftThick,
  },
  data() {
    return {
      page: 1,
      limit: process.env.VUE_APP_PAGE_LIMIT,
      next: Object,
      previous: Object,
      q: "",
      date: "",
      endDate: "",
    };
  },
  methods: {
    ...mapActions(["fetchQuotes"]),
    truncate,
    scrollTop(el) {
      this.$refs[el].scrollTo(0, 0);
    },
    search() {
      this.fetchQuotes({
        thePage: 1,
        theLimit: this.limit,
        q: this.q,
        date: this.date,
        endDate: this.endDate,
      });
    },
    searchQ() {
      this.fetchQuotes({
        thePage: 1,
        theLimit: this.limit,
        q: this.q,
        date: this.date,
        endDate: this.endDate,
        typing: true,
      });
    },
    rightClick() {
      this.page++;
      this.fetchQuotes({
        thePage: this.page,
        theLimit: this.limit,
        q: this.q,
        date: this.date,
        endDate: this.endDate,
        isloading: true,
      });
    },
    leftClick() {
      if (this.page !== 1) this.page--;
      this.fetchQuotes({
        thePage: this.page,
        theLimit: this.limit,
        q: this.q,
        date: this.date,
        endDate: this.endDate,
        isloading: true,
      });
    },
  },
  computed: mapGetters(["allQuotes", "nextQuote", "previousQuote"]),
  created() {
    this.fetchQuotes({
      thePage: this.page,
      theLimit: this.limit,
      q: this.q,
      date: this.date,
      endDate: this.endDate,
    });
  },
};
</script>

<style scoped>
</style>